module.exports = __webpack_public_path__ + "img/国防科技大学理学院.6a49717f.png";